import HControlDock from "@/components/spaces/HControlDock.modal.vue";
import HControlDockEdit from "@/components/spaces/HControlDockEdit.modal.vue";
import HForm from "@/components/spaces/HForm.modal.vue";
import HInfoPanel from "@/components/spaces/HInfoPanel.modal.vue";
import HMediaViewer from "@/components/spaces/HMediaViewer.modal.vue";

export default {
  HControlDock,
  HControlDockEdit,
  HForm,
  HInfoPanel,
  HMediaViewer,
};
